import styled from 'styled-components';

export const Navigation = styled.div`
  padding: 0 0 30px 0;
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
`;

export const Error = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
